import styled from "styled-components";

export const MainDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  background: #f0f2fa;
  overflow: hidden;
`;

export const ContentWrapDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 28px 32px 24px 32px;
  flex: 1;
  min-width: 0;
  overflow: auto;
  box-sizing: border-box;
  border-top: 5px solid #6366f1;
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;

  .page-title {
    font-weight: 900;
    font-size: 28px;
    color: #0f172a;
    letter-spacing: -0.5px;
  }

  .page-subtitle {
    font-size: 13px;
    color: #64748b;
    font-weight: 600;
    max-width: 640px;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
`;

export const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0 12px;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
`;

export const Mono = styled.span`
  font-family: "JetBrains Mono", Menlo, Consolas, monospace;
  font-size: 12px;
`;

export const PathRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;

  .ant-input {
    font-family: "JetBrains Mono", Menlo, Consolas, monospace;
    font-size: 12px;
  }
`;

export const InlineRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
`;
